import { useState, useRef, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useParams, useNavigate, useOutletContext } from 'react-router-dom'
import { userList } from '../../features/dashboard/UserSlice'
import { permissionStore, fetchRules } from '../../features/dashboard/PermissionSlice'
import Header from './Header';
import Button from '../form/Button';
import Loading from '../../Loading';
import { ToastContainer, toast } from 'react-toastify';
import Broadcast from './Broadcast';

function Permission(props) {
    const navigate = useNavigate()
    const url = useOutletContext()
    const { id } = useParams()
    const userId = useRef(id)
    const dispatch = useDispatch()
    const ruleId = useRef('')
    let [item, setItem] = useState({})
    let ref = useRef([])
    // const [profile, setProfile] = useState('')
    // const [situation, setSituation] = useState(false)
    const [status, setStatus] = useState(false)
    const [broadcastTitle, setBroadcastTitle] = useState('')

    const { users } = useSelector((state) => state.user)
    const {
        ruleList,
        success,
        loading,
        message,
        errorProfile
    } = useSelector((state) => state.permission)
    const checkHandler = (event, id) => {

        if (event.target.getAttribute('data-status') === 'true') {
            event.target.setAttribute('data-status', 'false')
        } else if (event.target.getAttribute('data-status') === null) {
            event.target.setAttribute('data-status', true)
        } else {
            event.target.setAttribute('data-status', true)
        }

        setItem({ ...item, [event.target.name]: event.target.getAttribute('data-status') })
        // setSituation(true)
    }

    const permissionStoreHandler = () => {
        const data = {
            'user_id': id,
            'item': item
        }
        dispatch(permissionStore(data))
    }

    const goToUserIndex = () => {
        navigate('/dashboard/user/index', { replace: true })
    }

    useEffect(() => {
        const data = {
            'user_id': id,
        }
        dispatch(userList())
        dispatch(fetchRules(data))
        if (success === true && status === true) {
            toast.success(message, {
                position: "top-center",
                autoClose: 600,
            })
            setStatus(false)
        }
        return () => {
            item = null
        }
    }, [])

    return (
        <>
            {loading ? (<Loading />) : null}
            <Broadcast title={' انتخاب سطح دسترسی منوها'} />


            <div className='row rahpardaznet-cart my-5 print-position'>
                <Header title={'انتخاب سطح دسترسی'} />
                <div className=" row col-12">

                    {
                        (Object.keys(ruleList).length > 0) ? (
                            ruleList.map((row, key) => (
                                <div className='col-12 col-md-4  mb-4'>
                                    <div className='rahpardaznet-permission-item'>
                                        <h5>
                                            <i className={row.icon + ' fa-fw fa-stack'}></i>
                                            {row.title}
                                        </h5>
                                        {
                                            (row.submenus.length > 0) ? (
                                                row.submenus.map((rule, index) => (
                                                    <div className="bg-light rounded">
                                                        <div className='d-flex justifycontent-start align-items-center form-check form-switch form-check-reverse'>
                                                            <input
                                                                name={rule.id}
                                                                type="checkbox"
                                                                id={`rule-${++index}`}
                                                                key={`rule-${++index}`}
                                                                ref={(element) => { ref.current[rule.id] = element }}
                                                                data-status={rule.userPermission}
                                                                defaultChecked={rule.userPermission}
                                                                className="form-check-input"
                                                                onChange={(e) => checkHandler(e, rule.id)}
                                                                role="switch"
                                                            />
                                                            <label className="form-check-label px-2" forhtml="flexSwitchCheckDefault">
                                                                <small>{rule.title}</small>
                                                            </label>
                                                        </div>
                                                    </div>
                                                ))
                                            ) : null
                                        }
                                    </div>
                                </div>
                            ))

                        ) : null
                    }
                </div>
            </div>
            <div className="row p-0">
                <div className='col-12 p-0'>
                <Button
                    tab='2'
                    title='برگشت به صفحه کاربران'
                    design="rahpardaznet-button outline"
                    event={goToUserIndex}
                />
                <Button
                    tab='1'
                    title='ثبت دسترسی'
                    design="rahpardaznet-button"
                    event={permissionStoreHandler}
                />
                </div>
            </div>
        </>
    )
}

export default Permission;